import axios from 'axios'
import { getSavedState, saveState } from '@state/helpers'
import { transform as transformUser } from '@src/api/transformers/userTransformer'

export const state = {
  currentUser: {},
  features: getSavedState('user.features'),
  userEmail: getSavedState('user.email'),
  userId: getSavedState('user.id'),
  seenSurveys: getSavedState('user.seenSurveys'),
  stateToken: null,
}

export const getters = {
  currentUser(state) {
    return state.currentUser
  },

  stateToken(state) {
    return state.stateToken
  },

  hasFeature(state) {
    return (featureSlug) => state.features?.includes(featureSlug)
  },

  seenSurveys(state) {
    return state.seenSurveys ?? []
  },

  hasHomeFeature(state, getters) {
    return getters.hasFeature('frontend-mottocenter-home')
  },

  hasUserProfileFeature(state, getters) {
    return getters.hasFeature('user-profile-management')
  },

  hasMyInfoProfileFeature(state, getters) {
    return getters.hasFeature('user-profile-management')
  },

  hasSmsPromptsFeature(state, getters) {
    return getters.hasFeature('sms-prompts')
  },

  isMottoCorporate(state) {
    return state.currentUser?.group?.accountTypeLabel === 'Motto Corporate'
  },

  canImpersonate(state, getters) {
    return getters.hasFeature('impersonate-user')
  },

  hasPersonnelFeature(state, getters) {
    return getters.hasFeature('personnel-management-frontend')
  },

  canManagePersonnel(state) {
    const groups = state.currentUser?.groups?.map((x) => x.label) || []
    return groups.includes('Broker Owner') || groups.includes('Operations Manager')
  },

  canManageNetworkConnect(state) {
    const groups = state.currentUser?.groups?.map((x) => x.label) || []
    return (
      groups.includes('Broker Owner') ||
      groups.includes('Operations Manager') ||
      (groups.includes('Loan Originator') && state.currentUser?.isLoPhaseTwo)
    )
  },

  isBoOrOpsManager(state) {
    const groups = state.currentUser?.groups?.map((x) => x.label) || []
    return groups.includes('Broker Owner') || groups.includes('Operations Manager')
  },

  shouldInitLogRocket(state, getters, rootState, rootGetters) {
    if (!rootGetters['auth/loggedIn']) {
      return false
    }
    const blockedEmails = ['mottomonitoring@mottomortgage.com']
    const userEmail = state.userEmail || ''
    const isValid = !blockedEmails.includes(userEmail.toLowerCase())

    const logRocketQAIds = [61011319, 61011320, 61011321]

    if (process.env.APP_ENV === 'prod' && isValid) {
      return true
    }

    return process.env.APP_ENV !== 'prod' && logRocketQAIds.includes(state.userId)
  },
}

export const mutations = {
  SET_CURRENT_USER(state, user) {
    state.currentUser = user
    state.features = user?.features
    state.userEmail = user?.primaryEmail
    state.userId = user?.id
    saveState('user.features', user?.features)
    saveState('user.email', user?.primaryEmail)
    saveState('user.id', user?.id)
  },

  SET_STATE_TOKEN(state, newValue) {
    state.stateToken = newValue
  },

  SET_SEEN_SURVEYS(state, surveyId) {
    const oldSurveys = state.seenSurveys ? [...state.seenSurveys] : []
    state.seenSurveys = [...oldSurveys.filter((x) => x !== surveyId), surveyId]
    saveState('user.seenSurveys', [...oldSurveys.filter((x) => x !== surveyId), surveyId])
  },
}

export const actions = {
  getMyUser({ commit, rootGetters }) {
    if (!rootGetters['auth/loggedIn']) {
      return
    }
    return axios
      .get(`/user`)
      .then((response) => {
        const user = response.data
        commit('SET_CURRENT_USER', transformUser(user))
        return user
      })
      .catch(() => {
        const errorMessage = 'Your session has expired. Please log in again'
        commit('auth/SET_ADMIN_AUTH_ERROR', errorMessage, { root: true })
      })
  },
}
